import {
  geofencesTransformer,
  geofenceTransformer,
} from './GeofenceTransformer';

import type { Geofence } from '@cobliteam/common-types';

import type { Configuration } from '../..';
import HttpMethod from '../../request/HttpMethod';
import Requester from '../../request/Requester';
import type { IRequest } from '../../request/Types';

export class GeofenceRequester {
  private requester: Requester;

  constructor(configuration: Configuration) {
    this.requester = new Requester(configuration);
  }

  public load = (): Promise<Geofence[]> => {
    const requestData: IRequest = {
      endpoint: '/geofences/',
      method: HttpMethod.GET,
    };

    return this.requester
      .request(requestData)
      .then((response) => geofencesTransformer(response.data));
  };

  public edit = (geofence: Geofence): Promise<Geofence> => {
    const requestData: IRequest = {
      endpoint: `/geofences/${geofence.id}`,
      method: HttpMethod.PUT,
      body: JSON.stringify({
        id: geofence.id,
        name: geofence.name,
        category: geofence.category,
        created_at: geofence.createdAt,
        geojson: geofence.geojson,
      }),
    };

    return this.requester
      .request(requestData)
      .then((response) => geofenceTransformer(response.data));
  };

  public save = (geofence: Geofence): Promise<Geofence> => {
    const requestData: IRequest = {
      endpoint: '/geofences/',
      method: HttpMethod.POST,
      body: JSON.stringify({
        name: geofence.name,
        category: geofence.category,
        geojson: geofence.geojson,
      }),
    };
    return this.requester
      .request(requestData)
      .then((response) => geofenceTransformer(response.data));
  };

  public delete = (geofence: Geofence): Promise<null> => {
    const requestData: IRequest = {
      endpoint: `/geofences/${geofence.id}`,
      method: HttpMethod.DELETE,
      body: JSON.stringify({
        id: geofence.id,
        created_at: geofence.createdAt,
        geojson: geofence.geojson,
      }),
    };
    return this.requester.request(requestData).then(() => null);
  };
}

export default GeofenceRequester;
